<template>
    <div class="publicMain">
        <div class="mianbao">
            <!--  -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
                <el-breadcrumb-item>服务访问</el-breadcrumb-item>
                <el-breadcrumb-item>服务回访</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="新建访问" name="first">
                <transition
                    name="fade"
                    appear
                    enter-active-class="animated bounceInRight"
                    leave-active-class="animated bounceInRight"
                    :duration="{ enter: 1200, leave: 1400 }"
                >
                    <serveReturnFirst v-if="activeName == 'first'" />
                </transition>
            </el-tab-pane>
            <el-tab-pane label="回访历史" name="second">
                <transition
                    name="fade"
                    appear
                    enter-active-class="animated bounceInLeft"
                    leave-active-class="animated bounceInLeft"
                    :duration="{ enter: 1200, leave: 1400 }"
                >
                    <serveReturnSecond v-if="activeName == 'second'" />
                </transition>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
// import {
//   getAllChildrenActiveList,
//   childrenActiveHomeEdit,
//   childrenActiveHomeDelete,
//   childrenActiveHomePass
// } from "./api";
import serveReturnFirst from "./components/serveReturnFirst.vue"
import serveReturnSecond from "./components/serveReturnSecond.vue"

export default {
    components: {
        serveReturnFirst,
        serveReturnSecond,
    },
    data() {
        return {
            currentPage: 1, //默认展示第一页
            buttonType: "", //按钮的类型
            row: {}, //点击当前按钮的row数据
            title: "",
            visible: false,
            activeName: "first", //el-tabs切换的
            formModel: {}, //模糊查询
            //table表格的column
            tableColumn: [
                {
                    prop: "theme",
                    label: "活动主题",
                },
                {
                    prop: "startTime",
                    label: "活动开始时间",
                },
                {
                    prop: "entTime",
                    label: "活动结束时间",
                },
                {
                    prop: "homeAddress",
                    label: "活动地点",
                },
                {
                    prop: "contacts",
                    label: "联系人",
                },
                {
                    prop: "contactNumber",
                    label: "联系电话",
                },
                {
                    type: "mode",
                    prop: "mode",
                    label: "参与方式",
                },
                {
                    type: "state",
                    prop: "state",
                    label: "状态",
                },
                {
                    type: "button",
                },
            ],
            //table表格的数据
            tableData: [],
            total: 0, //总数据
            pageNo: 1,
            pageSize: 10,
        }
    },
    methods: {
        //模糊搜索的查询
        onCheck() {
            this.getAllChildrenActiveListAPI({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.formModel,
            })
        },
        //模糊搜索的重置
        onReset() {
            this.formModel = {}
            this.getAllChildrenActiveListAPI({
                pageNo: 1,
                pageSize: 10,
            })
        },
        //每页请求N条数据
        handleSizeChange(val) {
            this.pageSize = val
            this.getAllChildrenActiveListAPI()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求N页数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.getAllChildrenActiveListAPI()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //增加
        add() {
            this.buttonType = "add"
            this.visible = true
            this.title = "新增"
        },
        //查看
        check(e) {
            this.buttonType = "check"
            this.row = e
            this.visible = true
            this.title = "查看"
        },
        //编辑
        compile(e) {
            this.buttonType = "compile"
            this.row = e
            this.visible = true
            this.title = "编辑"
        },
        //删除
        remove(e) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    childrenActiveHomeDelete({ id: e.id }).then((res) => {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                        this.getAllChildrenActiveListAPI()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //审核
        audit(e) {
            this.buttonType = "audit"
            this.row = e
            this.visible = true
            this.title = "审核"
        },
        //拿到发布活动的列表
        getAllChildrenActiveListAPI(e) {
            let params = Object.assign({}, e, {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            })
            getAllChildrenActiveList(params).then((res) => {
                this.tableData = res.content.list
                this.total = res.content.count
            })
        },
        //保存按钮
        save(e, type = "保存") {
            childrenActiveHomeEdit(e).then((res) => {
                this.$message({
                    message: type + "成功",
                    type: "success",
                })
                this.visible = false
                this.getAllChildrenActiveListAPI()
            })
        },
        //取消按钮
        cancel() {
            this.visible = false
        },
        //通过
        pass(row) {
            this.$confirm("确认通过吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    childrenActiveHomePass({ id: row.id, state: 3 }).then(
                        (res) => {
                            this.$message({
                                type: "success",
                                message: "操作成功!",
                            })
                            this.getAllChildrenActiveListAPI()
                        }
                    )
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    })
                })
        },
        //不通过
        unpass(row) {
            this.$confirm("确认撤销通过吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    childrenActiveHomePass({ id: row.id, state: 4 }).then(
                        (res) => {
                            this.$message({
                                type: "success",
                                message: "操作成功!",
                            })
                            this.getAllChildrenActiveListAPI()
                        }
                    )
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    })
                })
        },
    },
    created() {
        this.getAllChildrenActiveListAPI({
            pageNo: 1,
            pageSize: 10,
        })
    },
}
</script>

<style lang="less" scoped>
.publicMain {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
// 面包屑导航box
.mianbao {
    box-sizing: border-box;
    margin: -16px -16px 0;
    background-color: #eef1f6;
    height: 47px;
    align-items: center;
    padding-left: 16px;
    margin-bottom: 16px;
}
.childrenFileSelect {
    margin-top: 20px;
}
.table {
    margin: 20px 0px;
}
.add {
    margin: 20px 0px;
}
.slot {
    width: 90%;
    margin: auto;
}
</style>
